<template>
  <header v-if="currentRouteName != '404'" class="site-header">
    <img
      src="https://asset.hankooktire.com/content/dam/hankooktire/local/img/main/main-key-visual/pc/logo.svg"
      alt="Hankook"
      class="site-header__logo"
    />
    <nav class="site-header__nav">
      <router-link to="/" class="site-header__link">
        <i class="fa-solid fa-house"></i>
        <span>Accueil</span>
      </router-link>
      <router-link to="/old" class="site-header__link">
        <i class="fa-solid fa-clock-rotate-left"></i>
        <span>Offres terminées</span>
      </router-link>
      <a
        v-if="isStatusPage"
        :href="produitsEligiblesUrl"
        target="_blank"
        class="site-header__link"
      >
        <i class="fa-solid fa-list-check"></i>
        <span>Produits éligibles</span>
      </a>
      <a
        v-if="reglementUrl"
        :href="reglementUrl"
        target="_blank"
        class="site-header__link"
      >
        <i class="fa-solid fa-scale-balanced"></i>
        <span>Règlement</span>
      </a>
      <template v-if="isAuthenticated">
        <router-link to="/account/submissions" class="site-header__link">
          <i class="fa-solid fa-clock-rotate-left"></i>
          <span>Mes participations</span>
        </router-link>
        <router-link to="/account/profile" class="site-header__link">
          <i class="fa-solid fa-circle-user"></i>
          <span>Mon compte</span>
        </router-link>
      </template>
    </nav>
    <div class="site-header__right">
      <template v-if="isAuthenticated">
        <a @click="onLogout" class="site-header__link site-header__link--logout">
          <i class="fa-solid fa-right-from-bracket"></i>
          <span>Déconnexion</span>
        </a>
      </template>
      <template v-else-if="isStatusPage">
        <a @click="onStatusLogout" class="site-header__link site-header__link--logout">
          <i class="fa-solid fa-right-from-bracket"></i>
          <span>Déconnexion</span>
        </a>
      </template>
      <template v-else-if="!['home', 'old', 'login', 'register'].includes(currentRouteName)">
        <router-link to="/account/login" class="site-header__link">
          <i class="fa-regular fa-circle-user"></i>
          <span>Connexion</span>
        </router-link>
      </template>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      storedOperationId: sessionStorage.getItem("operationId") || null,
      storedProduitsUrl: sessionStorage.getItem("produitsEligiblesUrl") || null,
    };
  },
  mounted() {
    this.$root.$on("operation-id-loaded", this.onOperationIdLoaded);
    this.$root.$on("produits-eligibles-loaded", this.onProduitsEligiblesLoaded);
  },
  beforeDestroy() {
    this.$root.$off("operation-id-loaded", this.onOperationIdLoaded);
    this.$root.$off("produits-eligibles-loaded", this.onProduitsEligiblesLoaded);
  },
  watch: {
    $route() {
      this.storedOperationId = sessionStorage.getItem("operationId") || null;
      this.storedProduitsUrl =
        sessionStorage.getItem("produitsEligiblesUrl") || null;
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isStatusPage() {
      return (
        this.$route.name === "Status" ||
        this.$route.path.startsWith("/status/")
      );
    },
    reglementUrl() {
      const allowed = ["login", "register", "Status"];
      if (!allowed.includes(this.$route.name)) return null;
      const operationId = this.isStatusPage
        ? this.storedOperationId
        : this.$route.params._id || this.storedOperationId;
      if (!operationId) return null;
      return `https://oxoformdocs.fra1.digitaloceanspaces.com/${operationId}/reglement.pdf`;
    },
    produitsEligiblesUrl() {
      return this.storedProduitsUrl || "/Liste_Produits_Eligibles_mars_2024.pdf";
    },
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
      this.$router.push("/account/login");
    },
    onStatusLogout() {
      sessionStorage.removeItem("uid");
      sessionStorage.removeItem("_id");
      sessionStorage.removeItem("path");
      sessionStorage.removeItem("operationId");
      this.$router.push("/");
    },
    onOperationIdLoaded(id) {
      this.storedOperationId = id;
    },
    onProduitsEligiblesLoaded(url) {
      this.storedProduitsUrl = url || null;
    },
  },
};
</script>

<style>
.site-header {
  position: sticky;
  top: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 7px 24px;
  border-bottom: 4px solid #ec6608;
  gap: 32px;
}

.site-header__logo {
  height: 56px;
  padding: 6px 0;
}

.site-header__nav {
  display: flex;
  gap: 32px;
  flex: 1;
  justify-content: center;
}

.site-header__right {
  margin-left: auto;
}

.site-header__link {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #333;
  text-decoration: none;
  transition: color 0.2s;
  cursor: pointer;
}

.site-header__link:hover {
  color: #ec6608;
}
</style>
